import script from "./moduleShopInGoodsOrderPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleShopInGoodsOrderPrint.vue?vue&type=script&setup=true&lang=js"

import "./moduleShopInGoodsOrderPrint.vue?vue&type=style&index=0&id=456ff77e&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456ff77e"]])

export default __exports__